import axios from 'axios';
import lib from '@/lib';

export default class ShopModel {
	constructor() {
		this.allPaymentMethodsShow = false;
		this.orderHistoryShow = false;
		this.goldFeaturesShow = false;
	}
}
